<template>
	<div class="memberBenefits-container">
		<div class="memberBenefits-main">
			<div class="memberBenefits-content">
				<div class="term-banner"></div>
				<div class="term-content">
					<h3 class="memberBenefits-title">会员权益说明</h3>
					<div class="term-box">
						<div class="term-text">
							<p class="greeting">尊敬的会员：</p>
							<p class="intro">
								感谢您选择我们的高级会员和超级会员服务。为了保障服务的公平性和有效性，我们特此说明关于会员服务次数的使用规则：
							</p>

							<div class="term-item">
								<div class="term-number">1</div>
								<div class="term-desc">
									<b>服务次数发放：</b>
									<p>高级会员和超级会员每30日将定时发放特定次数的服务。这些服务次数是根据您的会员等级和所选套餐内容而定的。</p>
								</div>
							</div>

							<div class="term-item">
								<div class="term-number">2</div>
								<div class="term-desc">
									<b>使用期限：</b>
									<p>
										每30日发放的服务次数仅在该30日内有效。若您在该30日内未使用完所有服务次数，则剩余次数将在月底自动失效，无法累积至下个月或延期使用。
									</p>
								</div>
							</div>

							<div class="term-item">
								<div class="term-number">3</div>
								<div class="term-desc">
									<b>服务使用：</b>
									<p>您可以通过我们的平台或应用程序使用服务。在使用服务时，系统将自动扣除相应的服务次数。</p>
								</div>
							</div>

							<div class="term-item">
								<div class="term-number">4</div>
								<div class="term-desc">
									<b>注意事项：</b>
									<p>请务必在每30日结束前合理安排并使用您的服务次数，以免造成不必要的浪费。</p>
									<p>
										若您因特殊原因无法在该月内使用完所有服务次数，我们建议您提前与我们联系，了解是否有其他可行的解决方案或补偿措施（具体以我们的政策为准）
									</p>
								</div>
							</div>

							<div class="term-item">
								<div class="term-number">5</div>
								<div class="term-desc">
									<b>会员权益：</b>
									<p>
										除了每月定时发放的服务次数外，高级会员和超级会员还享有其他专属权益和优惠。具体权益和优惠内容请参见我们的会员政策或联系我们的客服人员了解。
									</p>
								</div>
							</div>

							<p class="conclusion">
								我们致力于为您提供优质、高效的服务。若您在使用过程中遇到任何问题或疑问，请随时与我们联系。感谢您的理解与支持！
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// 会员权益说明
	export default {
		name: 'Term',
		components: {},
		props: {},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	.memberBenefits-container {
		background-color: #f7f7f7;

		.memberBenefits-content {
			.term-banner {
				height: 400px;
				background: url('~@/assets/memberBenefits/banner.jpg') 50% 50% no-repeat;
				background-size: cover;
			}

			.term-content {
				width: $main-page-width;
				margin: 0 auto;
				padding: 50px 0;

				.term-box {
					background-color: #fff;
					border-radius: 10px;
					box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
					padding: 40px 60px;

					.term-text {
						font-size: 16px;
						color: #333;
						line-height: 1.8;

						.greeting {
							font-size: 18px;
							margin-bottom: 20px;
						}

						.intro,
						.conclusion {
							margin-bottom: 30px;
						}

						.term-item {
							display: flex;
							margin-bottom: 25px;

							.term-number {
								width: 30px;
								height: 30px;
								background: linear-gradient(90deg, #ffc664 0%, #ff9538 100%);
								border-radius: 50%;
								color: #fff;
								font-weight: bold;
								display: flex;
								align-items: center;
								justify-content: center;
								margin-right: 15px;
								flex-shrink: 0;
								margin-top: 3px;
							}

							.term-desc {
								flex: 1;

								b {
									color: #934e25;
									font-size: 17px;
								}

								p {
									margin: 8px 0;
								}
							}
						}
					}
				}
			}
		}

		.memberBenefits-title {
			font-size: 26px;
			color: #333;
			text-align: center;
			margin-bottom: 40px;
			position: relative;

			&::after {
				content: '';
				display: block;
				width: 60px;
				height: 3px;
				background: linear-gradient(90deg, #ffc664 0%, #ff9538 100%);
				margin: 15px auto 0;
			}
		}
	}
</style>
